// Containers saved before the cell could be resized have no `applyWidthToCell`
// flag, and are deliberately left on the old code path: the width styles only the
// inner div and the cell keeps its grid share, exactly as it always did. Newly
// inserted containers get the flag from createInitialData, and an existing one is
// moved over by ticking the setting.
const widthContainer: any = {
  Renderer: ({ data, children }: any) => (
    <div
      className="width-container"
      // Pinned: the cell is already the configured width, so fill it. Legacy: the
      // inner div carries the pixel width itself, which is the original behaviour.
      style={{ width: data?.applyWidthToCell ? '100%' : data?.width }}
    >
      {children}
    </div>
  ),
  // Pin the cell to an exact pixel width inside its row. flexBasis/width override
  // the react-page-cell-sm-* percentage from the 12 column grid, minWidth clears
  // the percentage floor that grid sets for sizes 3/6/9/12, and maxWidth keeps
  // the cell from overflowing a row narrower than the configured width.
  // Returning {} leaves the cell grid sized, which is what keeps legacy
  // containers - and every other cell in their row - rendering unchanged.
  cellOuterStyle: (data: any) =>
    data?.applyWidthToCell && typeof data?.width === 'number'
      ? {
          flexBasis: data.width,
          width: data.width,
          minWidth: 0,
          maxWidth: '100%',
        }
      : {},
  // Lets the cell be dragged wider/narrower by its own row handle, writing the
  // result straight back into the width setting so the number always matches what
  // is on screen. Only reachable for pinned cells.
  setCellPixelWidth: (width: number, data: any) => ({
    ...data,
    width: Math.round(width),
  }),
  // New containers resize as a whole element from the start.
  createInitialData: () => ({ width: 200, applyWidthToCell: true }),
  id: 'widthContainer',
  title: 'Width Container',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        width: { type: 'number', default: 200 },
        // No default on purpose. A default would be written into a container's
        // data as soon as its settings drawer mounts, which would convert an
        // existing container just by clicking on it.
        applyWidthToCell: {
          type: 'boolean',
          uniforms: {
            label: 'Resize the whole element (not just its contents)',
          },
        },
      },
    },
  },
};

export default widthContainer;
